import { render, staticRenderFns } from "./RecurringDataTable.vue?vue&type=template&id=39264402"
import script from "./RecurringDataTable.vue?vue&type=script&lang=js"
export * from "./RecurringDataTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports